import React, { useState } from 'react';
import { connect } from 'react-redux';
import ContentArea from '@episerver/spa-core/Components/ContentArea';

function Questions({epiData,context}) {


    return (
        <div className='questions-container'>
            <ContentArea
                noWrap
                key='QuestionsAndAnswersContentArea'
                context={context}
                data={epiData.questionsAndAnswersContentArea}
                propertyName='QuestionsAndAnswersContentArea'
            />
        </div>
    );
}

const mapStateToProps = (state) => ({
    epiData: state.equipmentListPage.epiData
});

export default connect(mapStateToProps)(Questions);
